import React, { useEffect, useState, useMemo, memo } from 'react';
import axios from 'axios';
import Table from '../shared/table/Table';
import useTranslations from '../../hooks/useTranslations';
import useUserLanguage from '../../hooks/useUserLanguage';
import { toast } from 'react-toastify';

const TableSwitch = memo(({ keyName, refreshList }) => {
    const [checked, setChecked] = useState(false);
    const [loading, setLoading] = useState(true);
  
    useEffect(() => {
      (async () => {
        try {
          const token = localStorage.getItem("admin_token");
          const { data } = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/permissions/item-status/${keyName}`,
            { headers:{ Authorization:`Bearer ${token}` } }
          );
          setChecked(Boolean(data?.is_visible));
        } catch (err) {
          console.error("⛔️ Status alınamadı:", err);
        } finally {
          setLoading(false);
        }
      })();
    }, [keyName]);
  
    const toggleVisibility = async () => {
      // Optimistic-UI
      setChecked(prev => !prev);
  
      try {
        const token = localStorage.getItem("admin_token");
        await axios.put(
          `${process.env.REACT_APP_API_BASE_URL}/api/permissions/update-visibility/${keyName}`,
          {},
          { headers:{ Authorization:`Bearer ${token}` } }
        );
        toast.success("Görünürlük güncellendi");
        refreshList();
      } catch (err) {
        console.error("⛔️ Güncelleme hatası:", err);
        toast.error("Hata oluştu");
        setChecked(prev => !prev);
      }
    };
  
    if (loading)
      return <span className="spinner-border spinner-border-sm" />;
  
    return (
      <div className="form-check form-switch text-end d-flex align-items-end justify-content-end">
        <input
          className="form-check-input custom-checkbox"
          type="checkbox"
          checked={checked}
          onChange={toggleVisibility}
          style={{ cursor:"pointer", width:45, height:22, transition:".2s" }}
        />
        <span
          className={`badge ms-2 ${checked ? "badge-success" : "badge-danger"}`}
          style={{ padding:"6px 12px", borderRadius:8, fontSize:14, fontWeight:"bold" }}
        />
      </div>
    );
  });
  

const NavigationBarStatus = () => {
  const [items, setItems] = useState([]);

  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = useMemo(
    () => (key, def) => translations[key] || def,
    [translations]
  );

  const fetchItems = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/permissions/navigation-items`, {

        headers: { Authorization: `Bearer ${token}` },
      });
      setItems(res.data);
    } catch (err) {
      console.error('Navigation verisi alınamadı:', err);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  const columns = useMemo(() => [
    {
      accessorKey: 'id',
      header: () => getText('TABLE_ID_LABEL', 'ID'),
      meta: { headerClassName: 'text-start', className: 'text-start' },
    },
    {
      accessorKey: 'title',
      header: () => getText('TABLE_TITLE_LABEL', 'Ad'),
      meta: { headerClassName: 'text-start', className: 'text-start' },
    },
    {
      accessorKey: 'is_visible',
      header: () => (
        <div style={{ textAlign: 'end' }}>{getText('TABLE_STATUS_LABEL', 'Görünürlük')}</div>
      ),
      meta: { headerClassName: 'text-end', className: 'text-end' },
      cell: (info) => (
        <TableSwitch
          keyName={info.row.original.key_name}
          isVisible={info.getValue() === 1}
          refreshList={fetchItems}
        />
      ),
    },
  ], [getText]);

  return <Table data={items} columns={columns} />;
};

export default NavigationBarStatus;
